export default "__VITE_ASSET__BHBAhrww__"